export default class Link {
  constructor (url) {
    this.url = url
  }
}
